import { CSSProperties } from 'react';
import { ClipLoader } from 'react-spinners';

interface IProps {
  size: number;
  override?: CSSProperties;
  color?: string;
}

const Loading = ({ size, override, color = '#fff' }: IProps) => (
  <ClipLoader
    color={color}
    loading={true}
    cssOverride={override}
    size={size}
    aria-label="Loading Spinner"
    data-testid="loader"
  />
);

export default Loading;
